module.exports = __webpack_public_path__ + "assets/img/icon_more_white.899bb3f3.svg";